<template>
  <div
    class="quotation-action-bar px-4 py-3"
    style="position: fixed; bottom: 0; width: 100%; border: 1px solid #dadada; background: #fff; z-index: 1;"
  >
    <v-row>
      <v-col cols="12">
        <AppButtonFlat size="small" color="success" block @click="openModal()">
          <v-icon>mdi-check-circle-outline</v-icon>
          Convert to Appointment
        </AppButtonFlat>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import QuotationConvertActionModal from "./QuotationConvertActionModal.vue";

const props = defineProps<{
  quotationId: string | number;
  onSuccess?: () => void;
}>();

const modal = useModalStore();

function openModal() {
  modal.open(
    QuotationConvertActionModal,
    {
      quotationId: props.quotationId,
      onSuccess: props.onSuccess,
    },
    { maxWidth: 420, showHeader: false },
  );
}
</script>
